import {
    put, takeLatest, all, call
} from 'redux-saga/effects'
import axios from 'axios';
import {
    GET_VISA_CARDS,
    ADD_VISA_TO_CART,
    FILTER_BAD_WORDS,
    GET_VISA_VIRTUAL_GIFT_TEMPLATES,
    getVisaCardsSuccess,
    getVisaCardsError,
    addVisaToCartSuccess,
    addVisaToCartError,
    getVisaCardsNoInventory,
    filterBadWordsSuccess,
    filterBadWordsError,
    getVisaVirtualGiftTemplatesSuccess, getVisaVirtualGiftTemplatesError,
} from "../actions/visaCards";

function* handleFetchVisaCards(action) {
    const includePlastic = parseInt(action.includePlastic);
    const includeVirtual = parseInt(action.includeVirtual);
    const cardNetwork = action.cardNetwork;
    try {
        const { data } = yield call(axios.request, {
            url: `/ajax/open-loop-products/?include_plastic_cards=${includePlastic}&include_virtual_cards=${includeVirtual}&card_network=${cardNetwork}`
        });

        if (data.no_inventory) {
            yield put(getVisaCardsNoInventory(data));
            return;
        }

        yield put(getVisaCardsSuccess(data));
    } catch (e) {
        yield put(getVisaCardsError(e.response));
    }
}

function* handleAddVisaToCart(action) {
    try {
        const { data } = yield call(axios.request, {
            url: `/ajax/cart/`,
            method: 'post',
            data: action.cards
        });
        yield put(addVisaToCartSuccess(data));
    } catch (e) {
        yield put(addVisaToCartError(e.response));
    }
}

function* handleBadWordsFilter(action) {
    try {
        const { data } = yield call(axios.request, {
            url: `/ajax/check-for-bad-words/`,
            method: 'post',
            data: action.data
        });
        yield put(filterBadWordsSuccess(data));
    } catch (e) {
        yield put(filterBadWordsError(e.response));
    }
}

function* handleFetchGiftTemplates(action) {
    try {
        const { data } = yield call(axios.request, {
            url: `/ajax/gift-templates/?page=${action.payload.page}&limit=${action.payload.limit}`
        });
        yield put(getVisaVirtualGiftTemplatesSuccess(data));
    } catch (e) {
        yield put(getVisaVirtualGiftTemplatesError(e.response));
    }
}

export function* visaCardsSagas() {
    yield all([
        takeLatest(GET_VISA_CARDS, handleFetchVisaCards),
        takeLatest(ADD_VISA_TO_CART, handleAddVisaToCart),
        takeLatest(FILTER_BAD_WORDS, handleBadWordsFilter),
        takeLatest(GET_VISA_VIRTUAL_GIFT_TEMPLATES, handleFetchGiftTemplates)
    ]);
}

export default visaCardsSagas;